import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import {Button,
        Dialog,
        DialogActions,
        DialogContent,
        DialogContentText,
        DialogTitle,
        CircularProgress,
        Checkbox,
        FormControlLabel,
        FormHelperText
} from "@material-ui/core";

// localStorage
import { useLocalStorage } from 'usehooks-ts'

import { sendNotification } from "../../context/UserContext";
import useStyles from './styles';
import ttAPI from '../../api/ttAPI';
import config from '../../config';

const CustomerUpdatePricingWithCPI = forwardRef((props, ref) => {
    const { closeMenu, onConfirmationSuccess, onUpdateSuccess } = props;
    const classes = useStyles();
    const [customerId, setCustomerId] = useState(-1);
    const [customerName, setCustomerName] = useState(-1);
    const [openConfirmCustomerDialog, setOpenConfirmCustomerDialog] = useState(false);
    const [cpi, setCpi] = useState();

    useImperativeHandle(ref, () => ({

      openConfirmationPopup(customerId, customerName) {
        setCustomerId(customerId);
        setCustomerName(customerName);
        handleClickCustomerConfirmationPopup();
      }

    }));

    useEffect(() => {
        let mounted = true;
        async function fetchData() {
            const response = await ttAPI.getCPI();
            if(mounted){
                setCpi(response);
            }
        }

        fetchData();

        return () => mounted = false;
    },[]);

    const handleClickCustomerConfirmationPopup = () => {
      closeMenu();
      setOpenConfirmCustomerDialog(true);
    };

    const handleCloseConfirmationCustomer = () => {
      setOpenConfirmCustomerDialog(false);
    };

    const handleConfirmCustomer = async() => {
        updateCustomerPricingWithCPI(customerId);
    };

    const updateCustomerPricingWithCPI = async (cid) => {
      const response = await ttAPI.updateCustomerPricingWithCPI(cid);
      if (response !== undefined && response.data !== undefined) {
            if (response.data.success) {
              sendNotification('success', 'Success - Customer Pricing (along with site pricing) adjusted according to CPI.', classes);
            }
            else {
              sendNotification('error', 'Failed to adjust pricing.', classes);
            }
      }

      handleCloseConfirmationCustomer();
    };



  return (
    <>
    <Dialog open={openConfirmCustomerDialog} onClose={handleCloseConfirmationCustomer} disableBackdropClick={true}

        PaperProps={{
          style: {
            boxShadow: 'none',
          },
        }}
    >
      <DialogTitle id="form-dialog-title">Update Customer Pricing based on CPI</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to adjust pricing for customer <span className={classes.bold}>{customerName}</span> ({customerId})?
          <br/>
          This will also adjust pricing for all related sites.
        </DialogContentText>
        {cpi !== undefined && cpi !== null && <DialogContentText>

            <span className={classes.bold}>Current CPI: </span>
            <div><span className={classes.bold}>Quarter:</span> {(new Date(cpi.quarter)).toLocaleString('en-nz', { month: 'short', year: '2-digit' })}</div>
            <div><span className={classes.bold}>Percentage:</span> {cpi.percentage}%</div>

        </DialogContentText>}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseConfirmationCustomer} className={classes.cancelButton}>
          Cancel
        </Button>
          <Button onClick={handleConfirmCustomer}>
            OK
          </Button>
      </DialogActions>
    </Dialog>
    </>
  );
});
export default CustomerUpdatePricingWithCPI;
